import './OverviewPage.css';
import { useContext, useEffect } from 'react';
import PageScaffold from '../components/PageScaffold';
import OverviewStatsContext from '../contexts/data/OverviewStatsContext';
import { ContextStatus, EProductType } from '@leedpulse-monorepo/enums';
import SubscriptionsContext from '../contexts/data/SubscriptionsContext';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';

import LeedflowOverview from '../components/overview_page/views/LeedflowOverview';
import LeedpulseOverview from '../components/overview_page/views/LeedpulseOverview';

export const OVERVIEW_PAGE_PATH = '/overview';
export const OVERVIEW_PAGE_TITLE = 'Tableau de bord';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OverviewPageProps { }

const OverviewPage: React.FC<OverviewPageProps> = (_) => {
  const overviewStatsContext = useContext(OverviewStatsContext);
  const subscriptionsContext = useContext(SubscriptionsContext);

  const [searchParams] = useSearchParams();
  // Le tableau de bord est dédié à Leedflow : le sélecteur d'app a été retiré.
  // La vue Leedpulse reste rendue par `?app=leedpulse`, seul accès qui lui
  // reste — plus aucun lien de l'interface n'y mène.
  const app = searchParams.get('app') || EProductType.LEEDFLOW;

  useEffect(() => {
    const now = dayjs();
    const lastAutoRefreshString = localStorage.getItem('lastAutoRefresh');
    const lastAutoRefresh = lastAutoRefreshString ? parseInt(lastAutoRefreshString, 10) : null;

    if (!lastAutoRefresh || now.isAfter(dayjs(lastAutoRefresh).add(1, 'day'))) {
      localStorage.setItem('lastAutoRefresh', now.valueOf().toString());
      window.location.reload();
    }

    if (overviewStatsContext.status === ContextStatus.IDLE) {
      overviewStatsContext.fetch();
    }
    return () => {
      overviewStatsContext.reset();
    };
  }, []);

  useEffect(() => {
    if (
      subscriptionsContext.status !== ContextStatus.LOADING ||
      subscriptionsContext.favoritesOnly === false
    ) {
      subscriptionsContext.fetchFavorites();
    }
    return () => subscriptionsContext.reset();
  }, []);

  return (
    <PageScaffold
      title={OVERVIEW_PAGE_TITLE}
      subtitle=" "
      breadcrumbItems={[
        {
          title: ' ',
        },
      ]}
    >
      {
        app === EProductType.LEEDPULSE ? <LeedpulseOverview /> :
          app === EProductType.LEEDFLOW ? <LeedflowOverview /> :
            null
      }
    </PageScaffold>
  );
};

export default OverviewPage;
